export const theme = {
    colors: {
        white: "#FFFFFF",
        almostBlack: "#1D1D1F",
        grey: "#666",
        silverChalice: "#86868B",
        alto: "#E5E5E7",
        wildSand: "#F5F5F7",
        whiteSmoke: "#EEEEEE",
        azure: "#0071E3",
        azureDark: "#005BB5",
        azureDarker: "#0055B3",
        fiord: "#35556E", // rgb(53, 85, 110)
        whiteTransparent: "rgba(255, 255, 255, 0.8)",
        blackTransparent: "rgba(0, 0, 0, 0.06)",
    },
    breakpoints: {
        mobile: "768px",
    },
    spacing: {
        small: "5px",
        medium: "10px",
        large: "20px",
    },
    borderRadius: {
        small: "8px",
        medium: "12px",
    },
};
